import React from 'react';
import { CALLS_USAGE_CAUTION_TEXT } from '../../constants/callsUsageCaution';
import './CallsUsageCaution.css';

const CallsUsageCaution = () => (
  <div className="calls-usage-caution" data-testid="calls-usage-caution" role="status">
    <p className="calls-usage-caution-text">
      <strong>Caution:</strong> {CALLS_USAGE_CAUTION_TEXT}
    </p>
  </div>
);

export default CallsUsageCaution;
